import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useQueryClient } from '@tanstack/react-query';
import useAuthAdminStore from '@/store/AdminAuthStore';

function SignOutUser() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setAuthAdminToken = useAuthAdminStore((state) => state.setAuthAdminToken);

  const handleClearCache = () => {
    queryClient.clear();
  };

  const signOut = () => {
    setAuthAdminToken(null);
    Cookies.remove('admin_token');
    navigate('/login');
    localStorage.removeItem('selectedLanguage');
    handleClearCache();
  };

  return signOut;
}

export default SignOutUser;
